import React from "react";
import Page from "components/Page";
import { Props } from "./AssetCustomFields";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const AssetCustomFields = lazyWithRetry(() => import("./AssetCustomFields"));

export default (props: Props) => (
  <Page>
    <AssetCustomFields {...props} />
  </Page>
);
